import React from "react";
import { colors } from "utils";

export const divider =
  <div style={{ backgroundColor: "white", display: "flex", height: "54px", width: "1px" }}></div>;

export const getSessionItem = (title, value) =>
  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
    <p style={{ fontSize: "18px", fontWeight: 700, lineHeight: "26px" }}>{title}</p>
    <div style={{ display: "flex", flexDirection: "row", fontSize: "14px", gap: "8px" }}>
      {value}
    </div>
  </div>;

export const getDate = ((startedAt) => {
  const date = new Date(startedAt);
  const dayOfWeek = date.toDateString().slice(0,3);
  const dateFormatted = (new Date(date - date.getTimezoneOffset() * 60000)).toISOString().slice(0,10);
  return dayOfWeek + " - " + dateFormatted;
});

export const getLength = ((startedAt, endedAt) => {
  if (!endedAt) {
    return 'Started at: ' + new Date(startedAt).toLocaleTimeString();
  } else {
    return new Date(startedAt).toLocaleTimeString() + ' - ' + new Date(endedAt).toLocaleTimeString();
  }
});

export const getDuration = ((startedAt, endedAt) => {
  if (!endedAt) {
    return 'IN PROGRESS';
  }
  const duration = new Date(endedAt) - new Date(startedAt);
  let seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
  hours = (hours < 10) ? "0" + hours : hours;
  minutes = (minutes < 10) ? "0" + minutes : minutes;
  seconds = (seconds < 10) ? "0" + seconds : seconds;
  return hours + ":" + minutes + ":" + seconds;
});

export const getSessionDate = (startedAt) => {
  if (!startedAt) return "N/A";
  const date = new Date(startedAt);
  if (isNaN(date.getTime())) return "N/A";
  const day = date.toLocaleDateString("en-US", { weekday: "short" });
  const formatted = date.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "2-digit" });
  const time = date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  return `${day}, ${formatted} \u2022 ${time}`;
};

export const getDurationMinutes = (startedAt, endedAt) => {
  if (!endedAt) return "IN PROGRESS";
  const start = new Date(startedAt);
  const end = new Date(endedAt);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return "N/A";
  const ms = end - start;
  const minutes = Math.max(0, Math.round(ms / 60000));
  return `${minutes} Minute${minutes !== 1 ? "s" : ""}`;
};

// The transition colors used for backgrounds elsewhere are too light to meet
// WCAG AA contrast as text on the light message bubble, so map them to their
// accessible darker variants when used for caps coloring.
const accessibleCapsColor = (color) => {
  switch (color) {
    case colors.blue500:
      return colors.blue700;
    case colors.pink500:
    case colors.pink700:
      return colors.pink800;
    default:
      return color;
  }
};

export const renderTextWithCapsColoring = (text, currentTransitionColor = colors.blue500) => {
  const capsColor = accessibleCapsColor(currentTransitionColor);
  // Replace all caps words with colored spans, but only for words 3+ characters long
  const processedText = text.replace(
    /\b[A-Z][A-Z\s!?.,]*[A-Z]\b|\b[A-Z]\b/g,
    (match) => {
      // Remove spaces and punctuation to check actual word length
      const cleanMatch = match.replace(/[\s!?.,]/g, '');
      if (cleanMatch.length >= 3) {
        return `<span style="color: ${capsColor}">${match}</span>`;
      }
      return match;
    }
  );

  return <span dangerouslySetInnerHTML={{ __html: processedText }} />;
};
